import { createSelector } from 'reselect';

export const userChangedModalSelector = state => state.userChangedModal;

export const userChangedModalVisibleSelector = createSelector(
  userChangedModalSelector,
  subState => subState.visible
);
